import { Distribution } from "types/Distribution";
import { ActionType, getType } from "typesafe-actions";
import * as distributionsActions from "./distributionsActions";

export type DistributionsState = {
  [distribution in 1 | 2 | 3]?: {
    [K in distributionsActions.DistributionContentType]?: {
      loading?: boolean;
      data?: Distribution[];
      error?: string;
    };
  };
};

export type DistributionsActions = ActionType<typeof distributionsActions>;

export default function distributions(
  state: DistributionsState = {},
  action: DistributionsActions
) {
  switch (action.type) {
    case getType(distributionsActions.load):
      return {
        ...state,
        [action.distribution]: {
          ...state[action.distribution],
          [action.contentType]: {
            ...(state[action.distribution] ?? {})[action.contentType],
            loading: true,
          },
        },
      };
    case getType(distributionsActions.loadSuccess):
      return {
        ...state,
        [action.distribution]: {
          ...state[action.distribution],
          [action.contentType]: { loading: false, data: action.data, error: undefined },
        },
      };
    case getType(distributionsActions.loadFail):
      return {
        ...state,
        [action.distribution]: {
          ...state[action.distribution],
          [action.contentType]: { loading: false, error: action.error },
        },
      };
    default:
      return state;
  }
}
